// The Sentry project's fingerprint rules regroup every plain `Error` by its
// message, overriding the fingerprint set on the scope. A dedicated error type
// keeps these out of that rule.

export class IncompleteCacheReadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'IncompleteCacheReadError';
  }
}

export class GraphQLNetworkError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'GraphQLNetworkError';
  }
}
